import React, { useEffect, useRef, useState } from 'react'

import FormPartOfTeam from './form/FormPartOfTeam'
import styles from './styles.module.scss'
// import image_form from "../../../../images/mirea/positions__list-banner-content-img.png";

const InterestingAndForm = ({ setCheckRef, checkDomenNameState, captchaSiteKey }) => {
  const [successForm, setSuccessForm] = useState(false)

  const checkRef = useRef(null)
  useEffect(() => {
    setCheckRef(checkRef)
  }, [])

  return (
    <div className={styles.wrapper} id="form">
      <div className={styles.left}>
        <p ref={checkRef} className={styles.title}>Оставьте свои контакты <br/>и мы свяжемся с Вами</p>
      </div>
      <div className={styles.right}>
        <p ref={checkRef} className={styles.title}>
          Становись частью команды
        </p>
        <div className={styles.form_block_wrapper}>
          {/* <div className={styles.form_block_wrapper_image}>
            <img src={image_form} alt='vector' draggable='false'/>
          </div> */}
          <div className={styles.form_block_wrapper_form}>
          {successForm && (
            <div className={styles.wrapper_total_right_success}>
              <p className={styles.wrapper_total_right_success_p1}>
                Заявка успешно отправлена!
              </p>
              <p>Мы скоро с тобой свяжемся.</p>
            </div>
          )}
          {!successForm && <FormPartOfTeam checkDomenNameState={checkDomenNameState} setSuccessForm={setSuccessForm} captchaSiteKey={captchaSiteKey} />}
          </div>
        </div>
      </div>
    </div>
  )
}

export default InterestingAndForm
